import React from 'react';
import { Zap, Target, Clock, Settings } from 'lucide-react';
import { Card } from './ui/card';

export const WhyProjectFlow = () => {
  const features = [
    {
      icon: Zap,
      title: 'Modern Automation',
      description: 'Designed specifically for industrial construction',
    },
    {
      icon: Target,
      title: 'Real-Time Alignment',
      description: 'Aligns cost, schedule, and field execution instantly',
    },
    {
      icon: Clock,
      title: 'Eliminates Lag',
      description: 'No more spreadsheet delays or data entry bottlenecks',
    },
    {
      icon: Settings,
      title: 'Reality-Engineered',
      description: 'Built around real project constraints, not generic software',
    },
  ];

  return (
    <section id="why" className="py-24 bg-[#0D1115] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Montserrat'] font-bold text-4xl sm:text-5xl text-[#F5F7F8] mb-6">
            WHY <span className="text-[#30D5C8]">PROJECT FLOW™</span>
          </h2>
          <div className="max-w-3xl mx-auto space-y-4">
            <p className="text-[#CBD3D9] text-lg sm:text-xl font-['Open_Sans'] leading-relaxed">
              Modern automation designed specifically for industrial construction.
            </p>
            <p className="text-[#CBD3D9] text-lg sm:text-xl font-['Open_Sans'] leading-relaxed">
              Eliminates spreadsheet lag. Aligns cost, schedule, and field execution in real time.
            </p>
            <p className="text-[#CBD3D9] text-lg sm:text-xl font-['Open_Sans'] leading-relaxed">
              Engineered around real project constraints — not generic software.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <Card
              key={index}
              className="bg-[#1A2733]/50 backdrop-blur-sm border-[#506273]/30 p-6 hover:border-[#30D5C8]/50 transition-all duration-300 card-hover group"
            >
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="w-16 h-16 bg-[#30D5C8]/10 rounded-xl flex items-center justify-center group-hover:bg-[#30D5C8]/20 transition-colors">
                  <feature.icon className="text-[#30D5C8]" size={32} />
                </div>
                <h3 className="font-['Montserrat'] font-bold text-xl text-[#F5F7F8]">
                  {feature.title}
                </h3>
                <p className="text-[#CBD3D9] font-['Open_Sans']">
                  {feature.description}
                </p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};